import { ICON_DELIVEREE_GREEN } from 'app/commons/constants/image.const'

import React from 'react'
import { useTranslation } from 'react-i18next'

import './PopupLogout.scss'

function PopupLogout() {
  const { t } = useTranslation()
  return (
    <div className="popup-logout__container">
      <div className="popup-logout__icon">
        <img height="79" src={ICON_DELIVEREE_GREEN} alt="Icon deliveree green" />
      </div>
      <div className="popup-logout__text">{t('common.editProfile.popupConfirmTitle')}</div>
    </div>
  )
}

export default PopupLogout
